import ButtonBase, { ButtonBaseTypeMap, ExtendButtonBase } from "@mui/material/ButtonBase";
import { styled } from "@mui/material/styles";
import { AUDIT_TOKENS } from "../../theme/auditTokens";

/**
 * The reference add-in's `.hv-btn`: bordered surface button, `primary` inverts to ink. Typed like
 * ButtonBase so that with `href` it takes anchor props such as `download`.
 */
export const AuditButton = styled(ButtonBase, {
  shouldForwardProp: prop => prop !== "primary",
})<{ primary?: boolean }>(({ primary }) => ({
  fontFamily: AUDIT_TOKENS.fontFamily,
  fontSize: 13.5,
  fontWeight: 600,
  lineHeight: 1.2,
  padding: "9px 16px",
  borderRadius: AUDIT_TOKENS.radius.control,
  border: `1px solid ${primary ? AUDIT_TOKENS.ink : AUDIT_TOKENS.line}`,
  background: primary ? AUDIT_TOKENS.ink : AUDIT_TOKENS.surface,
  color: primary ? "#fff" : AUDIT_TOKENS.text,
  transition: "border-color .15s, background .15s",
  whiteSpace: "nowrap",
  gap: 8,
  "&:hover": {
    borderColor: primary ? AUDIT_TOKENS.inkHover : AUDIT_TOKENS.lineHover,
    background: primary ? AUDIT_TOKENS.inkHover : AUDIT_TOKENS.surfaceHover,
  },
  "&.Mui-focusVisible": { outline: AUDIT_TOKENS.focusRing, outlineOffset: 1 },
  "&.Mui-disabled": { opacity: 0.55 },
  "@media (max-width: 820px)": { minHeight: 44, flex: "1 1 0" },
  "@media (prefers-reduced-motion: reduce)": { transition: "none" },
})) as ExtendButtonBase<ButtonBaseTypeMap<{ primary?: boolean }>>;

/** `.hv-link`: underlined accent text button. */
export const AuditLinkButton = styled(ButtonBase)({
  fontFamily: AUDIT_TOKENS.fontFamily,
  fontSize: 12.5,
  color: AUDIT_TOKENS.accent,
  textDecoration: "underline",
  padding: 0,
  "&.Mui-focusVisible": { outline: AUDIT_TOKENS.focusRing, outlineOffset: 1 },
  "@media (max-width: 820px)": { minHeight: 44 },
});
